module.exports = __webpack_public_path__ + "img/clock_icon.0fb699f7.svg";